module.exports = __webpack_public_path__ + "img/funplus.4f8e6d76.jpg";